module.exports = __webpack_public_path__ + "static/media/bottom_right_sparkles.9dcdb0cd.png";